import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { documentsSectionFromResponse } from '../../documents/recordDocumentsSection';
import { registryHref } from '../../registryHref';
export function companyRail(d, intel, docs, docsState) {
    return [
        {
            ...intel,
            rows: d.awards.map((a, i)=>({
                    id: `award-${i}`,
                    label: /*#__PURE__*/ _jsxs(SpecraLink, {
                        href: a.contract ? registryHref(a.contract) ?? undefined : undefined,
                        renderLink: renderRouterLink,
                        children: [
                            "Award: ",
                            a.label,
                            a.value ? `, ${new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                notation: 'compact'
                            }).format(a.value.amount)}` : ''
                        ]
                    }),
                    value: `${a.value?.measure === 'obligations' ? 'Obligations to date · ' : ''}${a.value?.source || 'Source not recorded'} · ${a.year}`
                })),
            children: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    intel.children,
                    !d.awards.length && /*#__PURE__*/ _jsx(SpecraText, {
                        as: "p",
                        size: "meta",
                        tone: "muted",
                        children: "No award values recorded yet."
                    })
                ]
            })
        },
        {
            id: 'pricing-sheets',
            title: 'Pricing sheets',
            rows: d.pricingSheets.map((s, i)=>({
                    id: s.generationId || `sheet-${i}`,
                    label: /*#__PURE__*/ _jsxs(SpecraLink, {
                        "data-testid": Testids.registryCompany.pricingSheetRow,
                        href: s.changeSetId ? registryHref({
                            kind: 'PRICING_SHEET',
                            id: s.changeSetId
                        }) ?? undefined : undefined,
                        renderLink: renderRouterLink,
                        children: [
                            s.vehicle?.name || s.title,
                            " ·",
                            ' ',
                            s.issuerKind === 'GOVERNMENT' ? 'from gov rate table' : `${s.generation} generation`
                        ]
                    }),
                    value: [
                        s.status === 'HISTORY' ? 'kept as history' : s.status === 'COMMITTED' ? `uploaded ${s.uploadedAt?.toDate().toLocaleDateString('en-GB', {
                            day: 'numeric',
                            month: 'short',
                            timeZone: 'UTC'
                        }) ?? 'date not recorded'}` : s.status.toLowerCase().replace(/_/g, ' '),
                        s.pendingPeriodDecisions ? `${s.pendingPeriodDecisions} period(s) to confirm` : '',
                        s.pendingBurdenDecisions ? `${s.pendingBurdenDecisions} burden decision(s) to confirm` : '',
                        s.rowCountNote
                    ].filter(Boolean).join(' · ')
                })),
            children: !d.pricingSheets.length ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "No pricing sheets recorded yet."
            }) : undefined
        },
        {
            id: 'lineage',
            title: 'Lineage',
            rows: d.lineage.map((l, i)=>({
                    id: l.relationshipId || `lineage-${i}`,
                    label: /*#__PURE__*/ _jsx(SpecraLink, {
                        "data-testid": Testids.registryCompany.lineageRow,
                        href: l.other ? registryHref(l.other) ?? undefined : undefined,
                        renderLink: renderRouterLink,
                        children: l.other?.name
                    }),
                    value: [
                        l.relationshipType === 'acquisition' ? l.direction === 'TO_US' ? 'acquired' : 'acquired by' : l.relationshipType.toLowerCase().replace(/_/g, ' '),
                        l.effectiveStart?.toDate().toLocaleDateString('en-GB', {
                            month: 'short',
                            year: 'numeric',
                            timeZone: 'UTC'
                        }),
                        l.effectiveEnd ? 'history' : ''
                    ].filter(Boolean).join(' · ')
                })),
            children: !d.lineage.length ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "No lineage recorded yet."
            }) : undefined
        },
        documentsSectionFromResponse({
            kind: 'COMPANY',
            id: d.companyId
        }, docs, docsState)
    ];
}
